var map = {
	"./act": 1516,
	"./act.tsx": 1516,
	"./gmat": 1517,
	"./gmat.tsx": 1517,
	"./gre": 1518,
	"./gre.tsx": 1518,
	"./ielts": 1519,
	"./ielts.tsx": 1519,
	"./ielts_general_training": 1520,
	"./ielts_general_training.tsx": 1520,
	"./lsat": 1521,
	"./lsat.tsx": 1521,
	"./mcat": 1522,
	"./mcat.tsx": 1522,
	"./sat": 1523,
	"./sat.tsx": 1523,
	"./toefl": 1524,
	"./toefl.tsx": 1524
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2534;
module.exports = webpackAsyncContext;